module.exports = __webpack_public_path__ + "img/bghe22.53b79b48.png";